import React from "react"
import { Leaf, Menu } from "lucide-react"
import { ThemeToggle } from "./ThemeToggle"
import { Button } from "../ui/button"

export function Header({ onMenuClick }) {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border-strong bg-background">
      <div className="container flex h-16 items-center px-4">
        <Button
          variant="ghost"
          size="icon"
          className="mr-2 md:hidden"
          onClick={onMenuClick}
          aria-label="Toggle menu"
        >
          <Menu className="h-5 w-5" />
        </Button>

        <div className="flex items-center space-x-2 mr-4">
          <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center">
            <Leaf className="h-5 w-5 text-primary-foreground" />
          </div>
          <span className="font-bold text-xl text-foreground">
            Agrotrack
          </span>
        </div>

        <div className="flex flex-1 items-center justify-end space-x-2">
          <ThemeToggle />
        </div>
      </div>
    </header>
  )
}
